import { createSelector } from 'reselect'

export const getActivitiesDetailLevel = (state, props) => {
  return state.kanbo.currentUser.settings.activitiesDetailLevel
}

export default createSelector(
  [
    getActivitiesDetailLevel,
  ],
  (
    activitiesDetailLevel,
  ) => ({
    activitiesDetailLevel,
  })
)
